/**
 * Block 14 «Раскрой» — PR #2-UI. Определения 6 вкладок рабочего экрана + SVG-
 * иконки (вербатим из `project.html`, stroke `#1a1512` → `currentColor`).
 *
 * Вынесено из `CuttingTabBar.tsx` отдельным модулем, чтобы файл компонента
 * экспортировал только компонент (react-refresh / fast-refresh).
 */

import type { ReactNode } from 'react';

export type CuttingTabId = 'menu' | 'settings' | 'details' | 'leftovers' | 'result' | 'estimate';

interface TabDef {
  id: CuttingTabId;
  label: string;
  icon: ReactNode;
}

export const CUTTING_TABS: readonly TabDef[] = [
  {
    id: 'menu',
    label: 'Меню',
    icon: (
      <svg className="sc-tab-icon" viewBox="0 0 32 24" aria-hidden="true">
        <line x1="4" y1="6" x2="28" y2="6" stroke="currentColor" strokeWidth="2.5" />
        <line x1="4" y1="12" x2="28" y2="12" stroke="currentColor" strokeWidth="2.5" />
        <line x1="4" y1="18" x2="28" y2="18" stroke="currentColor" strokeWidth="2.5" />
      </svg>
    ),
  },
  {
    id: 'settings',
    label: 'Настройки',
    icon: (
      <svg className="sc-tab-icon" viewBox="0 0 32 24" aria-hidden="true">
        <line x1="4" y1="6" x2="28" y2="6" stroke="currentColor" strokeWidth="2" />
        <circle cx="11" cy="6" r="3" fill="white" stroke="currentColor" strokeWidth="2" />
        <line x1="4" y1="12" x2="28" y2="12" stroke="currentColor" strokeWidth="2" />
        <circle cx="20" cy="12" r="3" fill="white" stroke="currentColor" strokeWidth="2" />
        <line x1="4" y1="18" x2="28" y2="18" stroke="currentColor" strokeWidth="2" />
        <circle cx="14" cy="18" r="3" fill="white" stroke="currentColor" strokeWidth="2" />
      </svg>
    ),
  },
  {
    id: 'details',
    label: 'Детали и кромки',
    icon: (
      <svg className="sc-tab-icon" viewBox="0 0 32 24" aria-hidden="true">
        <polygon
          points="6,7 22,7 26,11 10,11"
          fill="white"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <polygon
          points="6,13 22,13 26,17 10,17"
          fill="white"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    ),
  },
  {
    id: 'leftovers',
    label: 'Остатки',
    icon: (
      <svg className="sc-tab-icon" viewBox="0 0 32 24" aria-hidden="true">
        <rect
          x="8"
          y="4"
          width="14"
          height="10"
          fill="white"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <rect
          x="4"
          y="9"
          width="14"
          height="10"
          fill="white"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    ),
  },
  {
    id: 'result',
    label: 'Результат',
    icon: (
      <svg className="sc-tab-icon" viewBox="0 0 32 24" aria-hidden="true">
        <rect
          x="4"
          y="4"
          width="11"
          height="7"
          fill="white"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <rect
          x="17"
          y="4"
          width="11"
          height="7"
          fill="white"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <rect
          x="4"
          y="13"
          width="11"
          height="7"
          fill="white"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <rect
          x="17"
          y="13"
          width="11"
          height="7"
          fill="white"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    ),
  },
  {
    id: 'estimate',
    label: 'Смета',
    icon: (
      <svg className="sc-tab-icon" viewBox="0 0 32 24" aria-hidden="true">
        <circle cx="16" cy="12" r="9" fill="white" stroke="currentColor" strokeWidth="1.5" />
        <text x="16" y="16" textAnchor="middle" fontSize="11" fontWeight="700" fill="currentColor">
          ₽
        </text>
      </svg>
    ),
  },
];
